// extracted by mini-css-extract-plugin
export default {"section":"Categories_section__RrquF","box":"Categories_box__BHWaK","message":"Categories_message__Rm0oa"};